export const SET_GAME_URL = "SET_GAME_URL";
